import React from 'react';
import ReactDOM from 'react-dom/client';
import ApplicationProvider from './applicationProvider';
import App from './App';
import { IntlProvider } from 'react-intl';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const locale = 'en-IN';
root.render(
  <IntlProvider locale={locale}>
    <ApplicationProvider>
      <App />
    </ApplicationProvider>
  </IntlProvider>
);
